import o from "./semanticColors.js";
import r from "./primitiveColors.js";
const l = {
  ...r,
  ...o,
  neutral: {
    ...r.neutral,
    ...o.neutral
  }
};
export {
  l as default,
  r as primitiveColors,
  o as semanticColors
};
